import { PaymentType } from '@/features/graphql/generated/graphql'
import {
    PaymentDifference,
    ShiftCloseoutPaymentMethod,
    ShiftCloseoutPreviewData,
    ShiftCloseoutReconciliation,
} from '@/features/shiftCloseouts/types'
import currencyJs from 'currency.js'
import invariant from 'tiny-invariant'

type Handover = ShiftCloseoutPreviewData['handover']
type Differences = ShiftCloseoutReconciliation['differences']

const applyDifference = (
    expected: Handover['cash'],
    difference?: PaymentDifference
): Handover['cash'] => {
    if (!difference) return expected

    invariant(expected.currency === difference.amount.currency, 'Currencies mismatch')

    return {
        amount: currencyJs(expected.amount).add(difference.amount.amount).toString(),
        currency: expected.currency,
    }
}

export const calculateHandover = (
    expected: Handover,
    paymentMethods: ShiftCloseoutPaymentMethod[],
    differences: Differences
): Handover => {
    const getDifference = (paymentType: PaymentType): PaymentDifference | undefined => {
        const identifier = paymentMethods.find(
            (method) => method.paymentType === paymentType
        )?.identifier

        return identifier ? differences[identifier] : undefined
    }
    const cash = applyDifference(expected.cash, getDifference(PaymentType.Cash))
    const mealVouchers = applyDifference(
        expected.mealVouchers,
        getDifference(PaymentType.MealVoucher)
    )

    invariant(cash.currency === mealVouchers.currency, 'Currencies mismatch')

    return {
        cash,
        mealVouchers,
        total: {
            amount: currencyJs(cash.amount).add(mealVouchers.amount).toString(),
            currency: cash.currency,
        },
    }
}
